<template>
  <div class="work-plan">
    <el-tabs v-model="activeName" type="border-card">
      <el-tab-pane
        :label="$lange === 'en' ? 'Unit details' : '单元详情'"
        name="plan"
      >
        <div class="plan">
          <div class="plan-title flex-between">
            <p>
              <span
                >{{ $lange === "en" ? "Project" : "项目" }}:
                {{ projectName }}</span
              >
            </p>

            <p>
              <span>状态</span>
              <el-select
                size="mini"
                v-model="workPlanTableParams.status"
                :placeholder="$lange === 'en' ? 'Please select' : '请选择'"
                style="display: inline-block"
              >
                <el-option
                  :label="$lange === 'en' ? 'All' : '全部'"
                  value=""
                ></el-option>
                <el-option
                  :label="$lange === 'en' ? 'Not yet begun' : '未开始'"
                  :value="0"
                ></el-option>
                <el-option
                  :label="$lange === 'en' ? 'Have in hand' : '进行中'"
                  :value="1"
                ></el-option>
                <el-option
                  :label="$lange === 'en' ? 'Completed' : '已完成'"
                  :value="2"
                ></el-option>
                <el-option
                  :label="$lange === 'en' ? 'Delay' : '延期'"
                  :value="3"
                ></el-option>
              </el-select>
            </p>
            <p>
              <span>{{ $lange === "en" ? "Time" : "时间" }}</span>
              <span>
                <el-date-picker
                  size="mini"
                  v-model="dateValue"
                  value-format="yyyy-MM-dd"
                  @change="timeChange"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                >
                </el-date-picker>
              </span>
            </p>
            <el-button type="primary" size="mini" @click="doSearch">{{
              $lange === "en" ? "Search" : "搜索"
            }}</el-button>
            <p style="margin-left: auto">
              <el-button
                size="mini"
                type="primary"
                icon="el-icon-plus"
                @click="addProjectFun"
                >{{ $lange === "en" ? "Create unit" : "添加单元" }}</el-button
              >
            </p>
          </div>
          <div class="table-box not-padding">
            <cc-table
              :config="workPlanTableConfig"
              :params="workPlanTableParams2"
              :refeshParams="tableRefesh"
              :load-data="workshopProjectId > 0"
            ></cc-table>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane :label="language('workShop.阶段详情')" name="project">
        <div class="project">
          <div class="plan-title flex-between">
            <p class="flex-between">
              <span>{{ $lange === "en" ? "Unit" : "单元" }}</span>
              <el-input
                size="mini"
                :placeholder="
                  $lange === 'en' ? 'Please enter Unit name' : '请输入单元名称'
                "
                v-model="projectTableParams.workshopUnitName"
              ></el-input>
            </p>
            <p class="flex-between">
              <span>{{ $lange === "en" ? "Status" : "状态" }}</span>
              <el-select
                size="mini"
                v-model="projectTableParams.status"
                :placeholder="$lange === 'en' ? 'Please select' : '请选择'"
              >
                <el-option
                  :label="$lange === 'en' ? 'All' : '全部'"
                  value=""
                ></el-option>
                <el-option
                  :label="$lange === 'en' ? 'Hang in the air' : '未完成'"
                  :value="0"
                ></el-option>
                <el-option
                  :label="$lange === 'en' ? 'Completed' : '已完成'"
                  :value="1"
                ></el-option>
                <el-option
                  :label="$lange === 'en' ? 'Closed' : '已关闭'"
                  :value="2"
                ></el-option>
              </el-select>
            </p>
            <el-button type="primary" size="mini" @click="doSearch2">{{
              $lange === "en" ? "Search" : "搜索"
            }}</el-button>
          </div>
          <div class="table-box not-padding">
            <cc-table
              :config="projectTableConfig"
              :params="projectTableParams2"
              :refesh-params="tableRefesh"
              :load-data="workshopProjectId > 0"
            >
            </cc-table>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane :label="language('workShop.工序详情')" name="process">
        <template v-if="workshopProjectId">
          <processList ref="processList" :workshopProjectId="workshopProjectId"></processList>
        </template>
      </el-tab-pane>
    </el-tabs>
    <el-dialog
      :title="editId ? '单元编辑' : '单元创建'"
      :visible.sync="addProject"
      width="80%"
      @close="dialogClose"
    >
      <template v-if="addProject">
        <el-form
          ref="form"
          label-width="85px"
          size="mini"
          style="max-width: 95%"
          v-loading="loading"
        >
          <el-form-item
            :label="$lange === 'en' ? 'Unit' : '单元'"
            :required="true"
          >
            <el-input
              v-model="form.name"
              placeholder="请输入单元名称"
            ></el-input>
          </el-form-item>
          <!--<el-form-item :label="'订单号'" v-if=" ! editId">
            <el-input
              v-model="form.orderNo"
              placeholder="请输入采购订单号"
            ></el-input>
          </el-form-item>
          <el-form-item
            v-if=" ! editId"
            :label="'序号'"
            style="max-height: 200px; overflow: auto"
          >
            <el-select v-model="form.serialNo" clearable :placeholder="'请选择第几台'">
              <el-option :label="1" :value="1"></el-option>
              <el-option :label="2" :value="2"></el-option>
              <el-option :label="3" :value="3"></el-option>
              <el-option :label="4" :value="4"></el-option>
              <el-option :label="5" :value="5"></el-option>
              <el-option :label="6" :value="6"></el-option>
              <el-option :label="7" :value="7"></el-option>
              <el-option :label="8" :value="8"></el-option>
              <el-option :label="9" :value="9"></el-option>
              <el-option :label="10" :value="10"></el-option>
            </el-select>
          </el-form-item>-->
          <el-form-item
            :label="$lange === 'en' ? 'Class' : '负责班级'"
            :required="true"
            v-if="showTree"
            style="max-height: 200px; overflow: auto"
          >
            <el-select
              v-model="form.deptId"
              clearable
              :placeholder="language('workShop.请选择机械部门')"
            >
              <el-option
                v-for="item in classList"
                :label="item.fullname"
                :value="item.id"
              ></el-option>
            </el-select>
            <el-select
              v-model="form.deptId2"
              clearable
              style="margin: 0 10px"
              :placeholder="language('workShop.请选择电气部门')"
            >
              <el-option
                v-for="item in classList2"
                :label="item.fullname"
                :value="item.id"
              ></el-option>
            </el-select>
            <el-select
              v-model="form.deptId3"
              clearable
              :placeholder="language('workShop.请选择调试部门')"
            >
              <el-option
                v-for="item in classList3"
                :label="item.fullname"
                :value="item.id"
              ></el-option>
            </el-select>
            <el-input
              style="position: absolute; width: 200px; margin-left: 10px"
              v-model="form.keyword"
              placeholder="输入关键字快速匹配班组"
              @blur="handleBlur"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item
            :label="$lange === 'en' ? 'Start time' : '开始时间'"
            :required="true"
          >
            <el-date-picker
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              v-model="form.startTime"
            ></el-date-picker>
          </el-form-item>
          <el-form-item
            :label="$lange === 'en' ? 'End time' : '结束时间'"
            :required="true"
          >
            <el-date-picker
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              v-model="form.endTime"
            ></el-date-picker>
          </el-form-item>
          <el-form-item
            :label="$lange === 'en' ? 'Num' : '数量'"
            :required="true"
            v-if="showNum"
          >
            <el-input
              v-model="form.num"
              type="number"
              placeholder="请输入数量"
            ></el-input>
          </el-form-item>
          <el-form-item label=" " :required="true">
            <div class="form-table">
              <div class="flex-between search-box">
                <el-select
                  size="mini"
                  v-model="formTableConfigParamsV2.status"
                  :placeholder="
                    $lange === 'en'
                      ? 'Please select order status'
                      : '请选择订单状态'
                  "
                  @change="changeFormTableConfigParamsV2"
                >
                  <!--                                <el-option label="全部" value=""></el-option>-->
                  <el-option
                    :label="$lange === 'en' ? 'Unrelated' : '未关联'"
                    :value="0"
                  ></el-option>
                  <el-option
                    :label="$lange === 'en' ? 'Associated' : '已关联'"
                    :value="1"
                  ></el-option>
                </el-select>

                <el-input
                  style="display: inline-block"
                  size="mini"
                  :placeholder="
                    $lange === 'en'
                      ? 'Please enter order number'
                      : '请输入订单编号'
                  "
                  v-model="formTableConfigParamsV2.numbering"
                  @input="changenumbering"
                ></el-input>
              </div>
              <div class="table-box not-padding">
                <cc-table
                  :config="formTableConfig"
                  :params="formTableConfigParams"
                  :refesh-params="formTableRefesh"
                  :select-fun="formTableSelectFun"
                  @submit-select="formTableSelectedIds"
                ></cc-table>
              </div>
            </div>
          </el-form-item>

          <el-form-item style="margin-top: 20px">
            <el-button @click="addProject = false">{{
              $lange === "en" ? "Cancel" : "取消"
            }}</el-button>
            <el-button type="primary" @click="onSubmit">{{
              $lange === "en" ? "Submit" : "提交"
            }}</el-button>
          </el-form-item>
        </el-form>
      </template>
    </el-dialog>
    <div class="back-btn" @click="backBtn">
      <el-button
        type="danger"
        size="mini"
        icon="el-icon-circle-close"
      ></el-button>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import processList from "./processList";
export default {
  name: "PlanComponent",
  components: {
    processList,
  },
  data() {
    return {
      projectName: "---",
      dateValue: "",
      showTree: true,
      loading: false,
      workshopProjectId: false,
      formTableRefesh: 0,
      tableRefesh: 0,
      formTableConfigParams: {
        status: 0,
        numbering: "",
        selectedIds: [],
      },
      formTableConfigParamsV2: {
        status: 0,
        numbering: "",
        selectedIds: [],
      },
      formTableSelectFun: (row) => {
        let res = false;
        // if(this.formTableConfigParams.selectedIds || row.status === 0){  //编辑的时候为了取消做的兼容
        //     res = true;
        // }
        if (row.status === 0) {
          res = true;
        }
        return res;
      },
      formTableConfig: {
        selection: [],
        showPager: true,
        pageSize: 5,
        selectedText: true,
        api: "admin/fsb/workshop/order/query",
        columns: [
          {
            prop: "numbering",
            lable: this.$lange === "en" ? "Order" : "订单",
          },
          {
            prop: "status",
            lable: this.$lange === "en" ? "Status" : "状态",
            type: "tag",
            options: [
              {
                tagType: "info",
                text: this.$lange === "en" ? "Unrelated" : "未关联",
              },
              {
                tagType: "info",
                text: this.$lange === "en" ? "Associated" : "已关联",
              },
            ],
          },
        ],
      },
      editId: false,
      //工作计划表格
      workPlanTableConfig: {
        api: "admin/fsb/workshop/unit/query",
        pageSize: 10,
        showPager: true,
        columns: [
          {
            prop: "name",
            lable: this.$lange === "en" ? "Unit" : "单元",
          },
          {
            prop: "workshopOrderNum",
            lable: this.$lange === "en" ? "Order number" : "订单数量",
          },
          {
            prop: "estimatedWorkingHours",
            lable: this.language("workShop.标准工时"),
          },
          {
            prop: "actualWorkingHours",
            lable:
              this.$lange === "en" ? "Actual working hours" : "实际工时（小时）",
          },
          {
            prop: "expectedProduction",
            lable: this.$lange === "en" ? "Estimated yield" : "预估产量",
          },
          {
            prop: "actualProduction",
            lable: this.$lange === "en" ? "Actual output" : "实际产量",
          },
          {
            prop: "schedule",
            lable: this.$lange === "en" ? "Productiveness" : "效率",
          },
          {
            // prop: "productionSchedule",
            prop: "limitHoursSchedule",
            lable: this.$lange === "en" ? "Speed of progress" : "进度",
          },
          {
            prop: "deptName",
            lable: this.$lange === "en" ? "Class" : "负责班级",
          },
          {
            lable: this.$lange === "en" ? "Start time" : "开始时间",
            render: (row) => {
              return moment(row.startTime).format("YYYY-MM-DD");
            },
          },
          {
            lable: this.$lange === "en" ? "End time" : "结束时间",
            render: (row) => {
              return moment(row.endTime).format("YYYY-MM-DD");
            },
          },
          {
            prop: "status",
            lable: this.$lange === "en" ? "Status" : "状态",
            type: "tag",
            options: [
              {
                tagType: "info",
                text: this.$lange === "en" ? "Not yet begun" : "未开始",
              },
              {
                tagType: "warning",
                text: this.$lange === "en" ? "Have in hand" : "进行中",
              },
              {
                tagType: "success",
                text: this.$lange === "en" ? "Completed" : "已完成",
              },
              {
                tagType: "danger",
                text: this.$lange === "en" ? "Delay" : "延期",
              },
            ],
          },
        ],
        buttonsLabel: this.$lange === "en" ? "Operation" : "操作",
        buttons: [
          {
            name: this.$lange === "en" ? "Edit" : "编辑",
            click: (row) => {
              this.getClassList(row.id);
              this.editId = row.id;
              this.addProject = true;
              let data = JSON.parse(JSON.stringify(row));
              this.form = { ...data, deptId2: "", deptId3: "" };

              let deptId = this.form.deptId.split(",");
              if (deptId[0] * 1 > 0) {
                this.form.deptId = deptId[0] * 1;
              } else {
                this.form.deptId = "";
              }

              if (deptId[1] * 1 > 0) {
                this.form.deptId2 = deptId[1] * 1;
              } else {
                this.form.deptId2 = "";
              }
              if (deptId[2] * 1 > 0) {
                this.form.deptId3 = deptId[2] * 1;
              } else {
                this.form.deptId3 = "";
              }

              this.showTree = false;
              // this.formTableConfigParams.selectedIds = row.workshopOrderIds;
              this.formTableConfigParams.ids = row.workshopOrderIds;
              this.formTableConfigParams.status = 1;
              this.formTableConfigParamsV2.ids = row.workshopOrderIds;
              this.formTableConfigParamsV2.status = 1;

              setTimeout(() => {
                this.showTree = true;
                this.changeBgColor();
              }, 200);
            },
          },
          {
            name: this.$lange === "en" ? "Delete" : "删除",
            click: (row) => {
              this.$confirm("此操作会删除该单元, 是否确定?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              }).then(() => {
                let data = {
                  id: row.id,
                };
                this.ccRequest
                  .do("admin/fsb/workshop/unit/delete", data, "GET")
                  .then((res) => {
                    this.$message({
                      type: "success",
                      message: "单元已删除",
                    });
                    this.tableRefesh = new Date().getTime();
                  })
                  .catch((res) => {
                    this.$message({
                      type: "error",
                      message: res.response.data.message,
                    });
                  });
              });
            },
          },
          {
            name: "撤销工序",
            click: (row) => {
              this.$confirm("此操作会删除该单元下所有工序, 是否确定?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              }).then(() => {
                let workshopProcessIds = [];
                row.workshopOrderList.forEach(r => {
                  r.workshopProcessList.forEach(d => {
                    workshopProcessIds.push(d.id)
                  })
                });

                if (row.status !== 0) {
                  this.$message({type: "error", message: "不是未开始状态，无法撤销"});
                  return false;
                }

                this.ccRequest
                  .do("admin/fsb/process/bind/revokeChildrenProcess", {workshopUnitId: row.id, workshopProcessIds: workshopProcessIds}, "POST")
                  .then(() => {
                    this.$message({type: "success", message: "撤销成功"});
                    this.$refs.processList.doSearch2();
                  })
                  .catch((res) => {
                    this.$message({type: "error", message: res.response.data.message});
                  });
              });
            }
          }
        ],
      },
      workPlanTableParams: {
        workshopProjectId: "",
        status: "",
        startTime: "",
        endTime: "",
      },
      workPlanTableParams2: {
        workshopProjectId: "",
        status: "",
        startTime: "",
        endTime: "",
      },
      editUnitItem: {}, //当前编辑的单元
      editUnitFlag: false, //当前编辑的单元弹窗
      classList: [], //部门选择的数据
      classList2: [],
      classList3: [],
      //------
      searchTime: [],
      activeName: "plan",
      addProject: false, // 创建/编辑项目弹窗
      // 创建/编辑项目表单
      form: {
        name: "",
        startTime: "",
        endTime: "",
        deptId: "",
        workshopOrderIds: [],
        num: "",
        deptId2: "",
        deptId3: "",
        keyword: ""
      },
      projectTableParams: {
        workshopProjectId: "",
        status: "",
        workshopUnitName: "",
      },
      projectTableParams2: {
        workshopProjectId: "",
        status: "",
        workshopUnitName: "",
      },
      projectTableConfig: {
        api: "admin/fsb/workshop/project/details/query",
        showPager: true,
        columns: [
          {
            prop: "workshopUnit.name",
            lable: this.$lange === "en" ? "Unit" : "单元",
          },
          {
            prop: "workshopProcess.workshopOrder.numbering",
            lable: this.$lange === "en" ? "Order" : "订单",
          },
          {
            prop: "workshopProcess.content",
            lable: this.language("workShop.阶段"),
          },
          {
            prop: "workshopProcess.type",
            lable: this.language("workShop.阶段类型"),
            render: (rows) => {
              if (rows.workshopProcess) {
                if (rows.workshopProcess.type === "FC104") {
                  return "电气类";
                } else if (rows.workshopProcess.type === "FC101") {
                  return "机械类";
                } else if (rows.workshopProcess.type === "FC108") {
                  return "调试类";
                }
              }
            },
          },
          {
            prop: "workshopProcess.id",
            // lable: this.$lange === "en" ? "Process number" : "工序编号",
            lable: this.language("workShop.阶段编号"),
          },
          {
            prop: "childProcessNum",
            lable: this.language("workShop.工序数量"),
          },
          // {
          //   prop: "workshopProcess.expectedProduction",
          //   lable: this.$lange === "en" ? "Estimated output" : "预计产量",
          // },
          // {
          //   prop: "actualProduction",
          //   lable: this.$lange === "en" ? "Actual output" : "实际产量",
          // },
          // {
          //   prop: "workshopProcess.estimatedWorkingHours",
          //   lable:
          //     this.$lange === "en"
          //       ? "Estimated working hours"
          //       : "预计工时（小时）",
          // },
          {
            prop: "standardWorkingHours",
            lable: this.language("workShop.标准工时"),
          },
          {
            prop: "actualWorkingHours",
            lable:
              this.$lange === "en" ? "Actual working hours" : "实际工时（小时）",
          },
          {
            // prop: "workshopUnit.deptName",
            prop: "workshopProcess.deptName",
            lable: this.$lange === "en" ? "Responsible department" : "负责部门",
          },

          {
            prop: "actualPersonnel",
            lable: this.$lange === "en" ? "Practical personnel" : "实际人员",
          },
          {
            prop: "status",
            lable: this.$lange === "en" ? "Status" : "状态",
            type: "tag",
            options: [
              {
                tagType: "warning",
                text: this.$lange === "en" ? "Hang in the air" : "未完成",
              },
              {
                tagType: "success",
                text: this.$lange === "en" ? "Completed" : "已完成",
              },
              {
                tagType: "info",
                text: this.$lange === "en" ? "Closed" : "已关闭",
              },
            ],
          },
          {
            prop: "remark",
            lable: this.$lange === "en" ? "Remark" : "备注",
          },
        ],
        buttonsLabel: this.$lange === "en" ? "Operation" : "操作",
        buttons: [
          {
            name: this.language("workShop.关闭阶段"),
            check: (row) => {
              let res = false;
              if (row.status == 0 && this.showCloseStage) {
                res = true;
              }
              return res;
            },
            click: (row) => {
              this.$confirm("你当前操作是关闭阶段, 是否关闭?", "提示", {
                confirmButtonText: "关闭",
                cancelButtonText: "取消",
                type: "warning",
              }).then(() => {
                let data = {
                  id: row.id,
                  status: 1,
                };
                this.ccRequest
                  .do(
                    "admin/fsb/workshop/project/details/save",
                    data,
                    "POSTJSON"
                  )
                  // eslint-disable-next-line no-unused-vars
                  .then((res) => {
                    this.$message({
                      type: "success",
                      message: "阶段已关闭",
                    });
                    this.tableRefesh = new Date().getTime();
                  })
                  .catch((err) => {
                    this.$message({
                      type: "error",
                      message: err.response.data.message,
                    });
                  });
              });
              // this.$prompt("你当前操作是关闭工序, 请输入产量后确定", "提示", {
              //   confirmButtonText: "确定",
              //   cancelButtonText: "取消",
              //   inputPattern: /^[1-9]\d*$/,
              //   inputErrorMessage: "请输入正确的产量",
              //   type: "warning",
              // }).then((val) => {
              //   if (val.value > row.workshopProcess.expectedProduction) {
              //     return this.$message({
              //       type: "warning",
              //       message: "实际产量大于预计产量",
              //     });
              //   }
              //   let data = {
              //     id: row.id,
              //     actualProduction: val.value,
              //     status: 1,
              //   };
              //   this.ccRequest
              //     .do(
              //       "admin/fsb/workshop/project/details/save",
              //       data,
              //       "POSTJSON"
              //     )
              //     .then((res) => {
              //       this.$message({
              //         type: "success",
              //         message: "工序已关闭",
              //       });
              //       this.tableRefesh = new Date().getTime();
              //     });
              // });
            },
          },
          {
            name: this.$lange === "en" ? "Delete" : "删除",
            check: (row) => {
              return row.isDelete;
            },
            click: (row) => {
              this.$confirm(
                "你当前操作会取消关联订单下的所有工序, 是否确定?",
                "提示",
                {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "warning",
                }
              ).then(() => {
                let data = {
                  id: row.id,
                };
                this.ccRequest
                  .do("admin/fsb/workshop/project/details/delete", data, "GET")
                  // eslint-disable-next-line no-unused-vars
                  .then((res) => {
                    this.$message({
                      type: "success",
                      message: "单元已删除",
                    });
                    this.tableRefesh = new Date().getTime();
                  })
                  .catch((res) => {
                    this.$message({
                      type: "error",
                      message: res.response.data.message,
                    });
                  });
              });
            },
          },
        ],
      },
      showCloseStage: false, // 关闭工序按钮
      showNum: false, //num 数量字段填写
    };
  },
  methods: {
    changeFormTableConfigParamsV2(e) {
      if (e == 0) {
        this.formTableConfigParams.ids = "";
      } else {
        this.formTableConfigParams.ids = this.formTableConfigParamsV2.ids;
      }
      this.formTableConfigParams.status = e;
    },
    changenumbering(e) {
      this.formTableConfigParams.numbering = e;
    },
    doSearch() {
      this.workPlanTableParams2 = { ...this.workPlanTableParams };
    },
    doSearch2() {
      this.projectTableParams2 = { ...this.projectTableParams };
    },
    addProjectFun() {
      this.getClassList();
      this.formTableConfigParams.ids = "";
      this.formTableConfigParams.status = 0;
      this.formTableConfigParams.numbering = "";
      this.formTableConfigParamsV2.ids = "";
      this.formTableConfigParamsV2.status = 0;
      this.formTableConfigParamsV2.numbering = "";
      this.formTableRefesh = new Date().getTime();
      this.addProject = true;
    },
    backBtn() {
      this.$router.go(-1);
    },
    timeChange(res) {
      if (res) {
        this.workPlanTableParams.startTime = res[0];
        this.workPlanTableParams.endTime = res[1];
      } else {
        this.workPlanTableParams.startTime = "";
        this.workPlanTableParams.endTime = "";
      }
    },
    formTableSelectedIds(res) {
      this.form.workshopOrderIds = res;
    },
    dialogClose() {
      this.editId = false;
      this.form = {
        name: "",
        startTime: "",
        endTime: "",
        deptId: "",
        workshopOrderIds: [],
      };
    },
    changeBgColor() {
      setTimeout(() => {
        let nodes = document.getElementsByClassName("el-tree-node__content");
        for (let i = 0; i < nodes.length; i++) {
          let isChecked = nodes[i].getElementsByClassName("is-checked");
          if (isChecked.length > 0) {
            nodes[i].style.backgroundColor = "#edf9f6";
          } else {
            nodes[i].style.backgroundColor = "#ffffff";
          }
        }
      }, 200);
    },
    //新增时
    getClassList(unitId) {
      this.ccRequest
        .do("admin/fsb/workshop/unit/getDeptListByType", { type: 1 }, "GET")
        .then((res) => {
          this.classList = res;
          if (unitId) {
            this.ccRequest
              .do(
                "admin/fsb/workshop/unit/getUnitDept",
                { type: 1, unitId: unitId },
                "GET"
              )
              .then((res) => {
                if (res) {
                  let type = false;
                  for (let index = 0; index < this.classList.length; index++) {
                    if (this.classList[index].id == res.id) {
                      type = true;
                    }
                  }
                  if (!type) {
                    this.classList = [...this.classList, res];
                  }
                }
              });
          }
        });

      this.ccRequest
        .do("admin/fsb/workshop/unit/getDeptListByType", { type: 2 }, "GET")
        .then((res) => {
          this.classList2 = res;
          if (unitId) {
            this.ccRequest
              .do(
                "admin/fsb/workshop/unit/getUnitDept",
                { type: 2, unitId: unitId },
                "GET"
              )
              .then((res) => {
                if (res) {
                  let type = false;
                  for (let index = 0; index < this.classList2.length; index++) {
                    if (this.classList2[index].id == res.id) {
                      type = true;
                    }
                  }
                  if (!type) {
                    this.classList2 = [...this.classList2, res];
                  }
                }
              });
          }
        });
      this.ccRequest
        .do("admin/fsb/workshop/unit/getDeptListByType", { type: 3 }, "GET")
        .then((res) => {
          this.classList3 = res;
          if (unitId) {
            this.ccRequest
              .do(
                "admin/fsb/workshop/unit/getUnitDept",
                { type: 3, unitId: unitId },
                "GET"
              )
              .then((res) => {
                if (res) {
                  let type = false;
                  for (let index = 0; index < this.classList3.length; index++) {
                    if (this.classList3[index].id == res.id) {
                      type = true;
                    }
                  }
                  if (!type) {
                    this.classList3 = [...this.classList3, res];
                  }
                }
              });
          }
        });
    },
    //编辑时
    getClassListV2(unitId) {
      this.ccRequest
        .do(
          "admin/fsb/workshop/unit/getUnitDept",
          { type: 1, unitId: unitId },
          "GET"
        )
        .then((res) => {
          if (res) {
            this.classList = [res];
          } else {
            this.classList = [];
          }
        });
      this.ccRequest
        .do(
          "admin/fsb/workshop/unit/getUnitDept",
          { type: 2, unitId: unitId },
          "GET"
        )
        .then((res) => {
          if (res) {
            this.classList2 = [res];
          } else {
            this.classList2 = [];
          }
        });
      this.ccRequest
        .do(
          "admin/fsb/workshop/unit/getUnitDept",
          { type: 3, unitId: unitId },
          "GET"
        )
        .then((res) => {
          if (res) {
            this.classList3 = [res];
          } else {
            this.classList3 = [];
          }
        });
    },
    getData() {
      this.getClassList();
    },
    //提交创建 / 编辑 项目弹窗
    onSubmit() {
      let data = { ...this.form };
      if (data.name.length < 1) {
        this.$message({
          type: "error",
          message: "请输入单元名称",
        });
        return;
      }

      if (data.deptId === "" && data.deptId2 === "" && data.deptId3 === "") {
        this.$message({
          type: "error",
          message: "请最少选择一个部门",
        });
        return;
      }

      if (data.workshopOrderIds.length < 1) {
        this.$message({
          type: "error",
          message: "请选择工序",
        });
        return;
      }
      if (data.startTime.length < 1) {
        this.$message({
          type: "error",
          message: "请选择开始时间",
        });
        return;
      }
      if (data.endTime.length < 1) {
        this.$message({
          type: "error",
          message: "请选择结束时间",
        });
        return;
      }

      if (this.showNum) {
        if (data.num < 0 || data.num === "") {
          this.$message({
            type: "error",
            message: "请输入大于等于0的数量",
          });
          return false;
        }
      }

      if (data.startTime > data.endTime) {
        this.$message({
          type: "error",
          message: "开始时间不能大于结束时间",
        });
        return;
      }
      if (this.editId) {
        data.id = this.editId;
      }
      // 未知 *1  暂时隐藏
      // for(let i in data.workshopOrderIds){
      //     data.workshopOrderIds[i] = data.workshopOrderIds[i]*1
      // }
      data.workshopProjectId = this.projectTableParams.workshopProjectId;
      let deptId = [0, 0, 0];
      if (data.deptId) {
        deptId[0] = data.deptId;
      }
      if (data.deptId2) {
        deptId[1] = data.deptId2;
      }
      if (data.deptId3) {
        deptId[2] = data.deptId3;
      }
      data.deptId = deptId.join(",");
      this.ccRequest
        .do("admin/fsb/workshop/unit/save", data, "POSTJSON")
        // eslint-disable-next-line no-unused-vars
        .then((res) => {
          this.$message({
            type: "success",
            message: "操作成功",
          });
          this.addProject = false;
          this.tableRefesh = new Date().getTime();
        })
        .catch((res) => {
          this.$message({
            type: "error",
            message: res.response.data.message,
          });
        });
    },
    //取消创建 / 编辑 项目弹窗
    cancelAdd() {},
    handleBlur() {
      if (this.form.keyword) {
        this.loading = true;
        this.ccRequest
          .do('admin/fsb/unit/bind/findByName', {
            'unitName': this.form.keyword,
          }, 'GET').then((res) => {
          let deptId = res.data.teams.split(',')[0];
          let deptId2 = res.data.teams.split(',')[1];
          let deptId3 = res.data.teams.split(',')[2];
          this.form.deptId = deptId === '0' ? '' : parseInt(deptId);
          this.form.deptId2 = deptId2 === '0' ? '' : parseInt(deptId2);
          this.form.deptId3 = deptId3 === '0' ? '' : parseInt(deptId3);
          if (this.form.name === '') {
            this.form.name = this.form.keyword;
          }
          this.loading = false;
        }).catch((res) => {
          this.$message({type: "error", message: res.response.data.message});
          this.form.deptId = '';
          this.form.deptId2 = '';
          this.form.deptId3 = '';
          this.loading = false;
        });
      }
    }
  },
  mounted() {
    this.getValidate()
      .then((res) => {
        if (
          res.roleTips === "administrator" ||
          res.roleTips === "squadLeader" ||
          res.roleTips === "management"
        ) {
          this.showCloseStage = true;
          this.showNum = true;
        }
      })
      // eslint-disable-next-line no-unused-vars
      .catch((err) => {});
    if (this.$route.query.id) {
      this.workshopProjectId = this.$route.query.id;
      this.projectName = this.$route.query.name;
      this.workPlanTableParams.workshopProjectId = this.$route.query.id;
      this.projectTableParams.workshopProjectId = this.$route.query.id;

      this.workPlanTableParams2.workshopProjectId = this.$route.query.id;
      this.projectTableParams2.workshopProjectId = this.$route.query.id;
      // this.getData();
      return false;
    }
    this.$router.push({
      name: "DailyTotal",
    });
  },
};
</script>
<style>
.el-tree-node__content .el-checkbox {
  opacity: 0;
  display: none;
}
.el-tree-node__label {
  margin-left: 5px;
}
</style>
<style scoped lang="scss">
.project,
.plan {
  padding: 20px;
}

.table-box {
  margin-top: 20px;
}
.search-box {
  justify-content: flex-start;
  > * {
    margin-right: 20px;
    max-width: 160px;
  }
}
.plan-title {
  justify-content: flex-start;
  padding: 5px;
  padding-bottom: 20px;
  border-bottom: 1px solid #e4e4e4;
  > p {
    span {
      width: 35px;
      &:first-child {
        margin-right: 10px;
      }
    }

    &:not(:last-child) {
      margin-right: 30px;
    }
  }
}
</style>
